var spoiler_default = {
  "fontElementMap": "RE2GH",
  "hideText": "hyxK-",
  "onHoverText": "jjyog",
  "hideBlock": "_7VKjh",
  "smallBlur": "r6eZQ",
  "mediumBlur": "VGxfw",
  "largeBlur": "LG12V",
  "hideBlock_gallery": "AL1Ku",
  "overlay": "ETtpT",
  "overlay_gallery": "NuS2z",
  "revealSpoilerBtn": "EHVDz",
  "isMobile": "_9i4ff",
  "onHoverBtn": "wHM2C",
  "spoilerWrapper": "r0R7P",
  "spoilerDescription": "M34w-",
  "spoilerContainer": "sPBR5",
  "spoilerContainer_Gallery": "tNQgF"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
